import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'week'
})
export class WeekPipe implements PipeTransform {

  public static transform(date: Date | number, type: 'full' | 'short' = 'full'): string {

    if (typeof date == 'number') date = new Date(date);

    switch (date.getDay()) {
      case 1: return type == 'full' ? 'Thứ 2' : 'T2';
      case 2: return type == 'full' ? 'Thứ 3' : 'T3';
      case 3: return type == 'full' ? 'Thứ 4' : 'T4';
      case 4: return type == 'full' ? 'Thứ 5' : 'T5';
      case 5: return type == 'full' ? 'Thứ 6' : 'T6';
      case 6: return type == 'full' ? 'Thứ 7' : 'T7';
      default: return type == 'full' ? 'Chủ Nhật' : 'CN';
    }
  }

  public transform(date: Date | number, type: 'full' | 'short' = 'full'): string {
    return WeekPipe.transform(date, type);
  }
}
